import { commonService } from './common';

const getClientConfiguration = () => commonService.request('GET', `public/configuration`, {}, commonService.HEADER_TYPES.PUBLIC);

export const configurationService = {
    getClientConfiguration,
};
